import { Container, Sprite } from 'pixi.js';

import { Shared } from '../../App';

export class BillboardArrow extends Container
{
    private white: Sprite;
    private red: Sprite;
    private highlighted: boolean;
    private pressed: boolean;

    constructor()
    {
        super();
        this.normal();
        this.white = new Sprite(Shared.assets.getTexture('tt-billboard-arrow-white'));
        this.white.anchor.set(0.5);
        this.addChild(this.white);

        this.red = new Sprite(Shared.assets.getTexture('tt-billboard-arrow-red'));
        this.red.anchor.set(0.5);
        this.addChild(this.red);

        this.highlighted = false;
        this.pressed = false;
        this.refresh();
    }

    private refresh(): void
    {
        if (this.pressed)
        {
            this.red.alpha = this.highlighted ? 1 : 0.2;
        }
        else
        {
            this.red.alpha = this.highlighted ? 0.3 : 0;
        }
    }

    public highlight(): void
    {
        if (this.highlighted) return;
        this.highlighted = true;
        this.refresh();
    }

    public normal(): void
    {
        if (!this.highlighted) return;
        this.highlighted = false;
        this.refresh();
    }

    public press(): void
    {
        if (this.pressed) return;
        this.pressed = true;
        this.refresh();
    }

    public release(): void
    {
        if (!this.pressed) return;
        this.pressed = false;
        this.refresh();
    }
}
